/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled, { css } from 'styled-components';

import { MapZoomPickerType } from '../utilities/interfaces';
import { REGION_ZOOM_IMG, CITY_ZOOM_IMG, COUNTRY_ZOOM_IMG } from './assets/base64Imgs';

const ZOOM_LEVEL_ITEMS = [
    {
        id: 'city',
        label: 'City',
        image: CITY_ZOOM_IMG,
        zoom: 11
    },
    {
        id: 'region',
        label: 'Region',
        image: REGION_ZOOM_IMG,
        zoom: 7
    },
    {
        id: 'country',
        label: 'Country',
        image: COUNTRY_ZOOM_IMG,
        zoom: 4
    }
];

export const MapZoomPicker = memo(({
    onClickHeaderImage,
    headerImage,
    currentZoomLevel,
    onItemPressed,
    zoomPickerMenuPosition,
    zoomPickerMenuId,
    zoomPickerMenuHeaderStyle
}: MapZoomPickerType) => {
    return (
        <MapZoomPickerControlContainer
            id={zoomPickerMenuId ? zoomPickerMenuId : 'mapZoomPickerControlContainer'}
            zoomPickerMenuPosition={zoomPickerMenuPosition}>

            <MapZoomPickerControlHeader zoomPickerMenuHeaderStyle={zoomPickerMenuHeaderStyle}>
                Zoom <HeaderImageFromComponent
                    onClick={() => {
                        onClickHeaderImage();
                    }}>
                    {headerImage}
                </HeaderImageFromComponent>
            </MapZoomPickerControlHeader>
            <MapZoomPickerControlBody>
                <MapZoomPickerControlItemList>
                    {ZOOM_LEVEL_ITEMS.map(item => {
                        const itemStyle = currentZoomLevel === item.zoom;
                        return (
                            <MapZoomPickerControlItem
                                key={item.id}
                                selectedItem={itemStyle}
                                onClick={() => {
                                    onItemPressed(item.zoom);
                                }}>
                                <MapsZoomPickerControlItemImage
                                    src={item.image}
                                    alt={`${item.label} Zoom`}
                                />
                                {item.label}
                            </MapZoomPickerControlItem>
                        );
                    })}
                </MapZoomPickerControlItemList>
            </MapZoomPickerControlBody>
        </MapZoomPickerControlContainer>
    );
});

interface MapZoomPickerControlContainerProps {
    zoomPickerMenuPosition: string;
}
const MapZoomPickerControlContainer = styled.div<MapZoomPickerControlContainerProps>`
    width: 239px;
    height: 260px;
    background-color: #FFFFFF;
    position: ${({ zoomPickerMenuPosition }) => zoomPickerMenuPosition ? zoomPickerMenuPosition : 'absolute'};
`;

interface MapZoomPickerControlHeaderProps {
    zoomPickerMenuHeaderStyle: string;
}
const MapZoomPickerControlHeader = styled.h3<MapZoomPickerControlHeaderProps>`
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 600;
    color: #555;
    font-family: 'Source Sans Pro', sans-serif;
    padding-left: 15px;
    padding-bottom: 11px;
    margin-bottom: 0px;
    ${({ zoomPickerMenuHeaderStyle }) => zoomPickerMenuHeaderStyle
        ? zoomPickerMenuHeaderStyle
        : ''
};
`;

const MapZoomPickerControlBody = styled.div`
    border-top: 1px solid #d8d8d8;
`;

const MapZoomPickerControlItemList = styled.ul`
    list-style: none;
    padding: 0px;
    color: #555;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: bold;
    font-size: 13px;
`;

interface MapZoomPickerControlItemProps {
    selectedItem: boolean;
}
const MapZoomPickerControlItem = styled.li<MapZoomPickerControlItemProps>`
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
    ${({ selectedItem }) => selectedItem
        ? `background-color: #2E98E3;
            color: #FFFFFF;`
        : `&:hover {
            background-color: #EEEEEE;
          }`
};
`;

const MapsZoomPickerControlItemImage = styled.img`
    width: 43px;
    height: 43px;
    margin-right: 10px;
`;

const HeaderImageSharedStyle = css`
    float: right;
    margin-right: 20px;
    cursor: pointer;
    &:hover: {
        background-color: "#EEEEEE"
    }
`;

const HeaderImageFromUrl = styled.img`
    ${HeaderImageSharedStyle}
`;

const HeaderImageFromComponent = styled.div`
    ${HeaderImageSharedStyle}
`;
